/**
 * Determines if a given locale is written in a right-to-left (RTL) script.
 *
 * @param {string} locale - The locale code to check (e.g., 'ar', 'he', 'fa').
 * @returns {boolean} - Returns `true` if the locale is associated with an RTL script, otherwise `false`.
 *
 * @remarks
 * This function uses a predefined list of RTL scripts to determine the result.
 * It should be removed when `Intl.Locale(locale).getTextInfo()` becomes widely supported across browsers.
 *
 * @example
 * ```typescript
 * isRTL('ar'); // true
 * isRTL('en'); // false
 * ```
 */
// remove when new Intl.Locale(locale).getTextInfo() is available cross browser
export function isRTL(locale: string): boolean {
  try {
    const rtlScripts = [
      'ar', // Arabic
      'he', // Hebrew
      'fa', // Persian (Farsi)
      'ur', // Urdu
      'ps', // Pashto
      'sd', // Sindhi
      'ug', // Uyghur
      'dv', // Divehi (Maldivian)
      'nqo', // N'Ko
      'syr', // Syriac
      'arc' // Aramaic
    ];

    return rtlScripts.includes(locale) ?? false;
  } catch {
    return false;
  }
}
